import React from 'react';
import './MapLocation.scss';

const MAP_EMBED_SRC =
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2880.5715096042877!2d-79.49005962379913!3d43.78175277109628!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b2e14a8fba617%3A0x6bbe7dd83925d624!2s2%20Shale%20Gate%2C%20North%20York%2C%20ON%20M3J%202Y8!5e0!3m2!1sen!2sca!4v1778876830252!5m2!1sen!2sca';

export default function SimpleMap() {
    return (
        <div className="map-embed-wrapper" draggable={false}>
            <iframe
                title="2 Shale Gate, North York, ON M3J 2Y8"
                src={MAP_EMBED_SRC}
                width="600"
                height="450"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
            />
        </div>
    );
}
